<div class="connections-container" [class.full-width]="fullWidth()">
  <mat-card class="connections-card">
    @if (loading()) {
      <div class="loading-container">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    }

    @if (!loading() && displayConnections().length === 0) {
      <div class="empty-state">
        <mat-icon class="empty-icon">cloud_off</mat-icon>
        <h3 class="empty-title">No connections found</h3>
        <p class="empty-description">
          Get started by creating your first connection to external services.
        </p>
      </div>
    }

    @if (!loading() && displayConnections().length > 0) {
      @if (fullWidth()) {
        <div class="connections-table-wrapper">
          <div class="connections-table-header">
            <div class="col type-col">Type/Name</div>
            <div class="col description-col">Description</div>
            <div class="col status-col">Status</div>
            <div class="col actions-col"></div>
          </div>
          <div class="connections-table-body">
            @for (connection of displayConnections(); track connection.id) {
              <div class="connections-table-row">
                <div class="col type-col">
                  <div class="type-name-content">
                    <mat-icon
                      [svgIcon]="connection.svgIcon"
                      class="type-icon type-icon-{{ connection.type }}"
                      aria-hidden="true"
                    ></mat-icon>
                    <span class="name-text">{{ connection.name }}</span>
                  </div>
                </div>
                <div class="col description-col">
                  <span class="description-text">{{
                    connection.description
                  }}</span>
                </div>
                <div class="col status-col">
                  <mat-icon
                    class="status-icon"
                    [class.active]="connection.status !== 'inactive'"
                    [class.inactive]="connection.status === 'inactive'"
                  >
                    {{ connection.status === "inactive" ? "close" : "check" }}
                  </mat-icon>
                  @if (connection.isOAuthExpired) {
                    <mat-chip
                      class="oauth-expired-chip"
                      matTooltip="OAuth credential has expired — re-authorize this connection"
                    >
                      <mat-icon matChipAvatar>warning</mat-icon>
                      Expired
                    </mat-chip>
                  }
                </div>
                <div class="col actions-col">
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="connectionMenu"
                    class="action-menu-button"
                    [attr.aria-label]="
                      'Connection actions for ' + connection.name
                    "
                  >
                    <img
                      src="assets/icons/connection-more-horiz.svg"
                      alt=""
                      class="more-horiz-icon"
                      width="16"
                      height="16"
                    />
                  </button>
                  <mat-menu
                    #connectionMenu="matMenu"
                    panelClass="connection-dropdown-menu"
                  >
                    <button
                      mat-menu-item
                      class="connection-menu-item connection-menu-item-edit"
                      (click)="onActionMenu(connection, 'edit')"
                    >
                      <img
                        [attr.matMenuItemIcon]="''"
                        src="assets/icons/connection-edit.svg"
                        alt=""
                        class="menu-icon"
                        width="16"
                        height="16"
                      />
                      <span class="connection-menu-item-label">Edit</span>
                    </button>
                    <button
                      mat-menu-item
                      class="connection-menu-item connection-menu-item-test"
                      (click)="onActionMenu(connection, 'test')"
                    >
                      <mat-icon
                        class="menu-icon menu-mat-icon"
                        [attr.matMenuItemIcon]="''"
                        >autorenew</mat-icon
                      >
                      <span class="connection-menu-item-label">Test</span>
                    </button>
                    @if (canDuplicate(connection)) {
                      <button
                        mat-menu-item
                        class="connection-menu-item connection-menu-item-duplicate"
                        (click)="onActionMenu(connection, 'duplicate')"
                      >
                        <mat-icon
                          class="menu-icon menu-mat-icon"
                          [attr.matMenuItemIcon]="''"
                          >content_copy</mat-icon
                        >
                        <span class="connection-menu-item-label">Duplicate</span>
                      </button>
                    }
                    <button
                      mat-menu-item
                      class="connection-menu-item connection-menu-item-remove menu-item-remove"
                      (click)="onActionMenu(connection, 'delete')"
                    >
                      <img
                        [attr.matMenuItemIcon]="''"
                        src="assets/icons/connection-remove.svg"
                        alt=""
                        class="menu-icon"
                        width="16"
                        height="16"
                      />
                      <span class="connection-menu-item-label">Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="connections-list">
          @for (connection of displayConnections(); track connection.id) {
            <div class="connection-item">
              <div class="connection-header">
                <div class="connection-name">
                  <mat-icon
                    [svgIcon]="connection.svgIcon"
                    class="connection-type-icon type-icon-{{ connection.type }}"
                    aria-hidden="true"
                  ></mat-icon>
                  <span class="name-text">{{ connection.name }}</span>
                  @if (connection.isOAuthExpired) {
                    <mat-chip
                      class="oauth-expired-chip"
                      matTooltip="OAuth credential has expired — re-authorize this connection"
                    >
                      <mat-icon>warning</mat-icon>
                      Expired
                    </mat-chip>
                  }
                </div>
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="compactConnectionMenu"
                  class="action-menu-button"
                  [attr.aria-label]="
                    'Connection actions for ' + connection.name
                  "
                >
                  <img
                    src="assets/icons/connection-more-horiz.svg"
                    alt=""
                    class="more-horiz-icon"
                    width="16"
                    height="16"
                  />
                </button>
                <mat-menu
                  #compactConnectionMenu="matMenu"
                  panelClass="connection-dropdown-menu"
                >
                  <button
                    mat-menu-item
                    class="connection-menu-item connection-menu-item-edit"
                    (click)="onActionMenu(connection, 'edit')"
                  >
                    <img
                      [attr.matMenuItemIcon]="''"
                      src="assets/icons/connection-edit.svg"
                      alt=""
                      class="menu-icon"
                      width="16"
                      height="16"
                    />
                    <span class="connection-menu-item-label">Edit</span>
                  </button>
                  <button
                    mat-menu-item
                    class="connection-menu-item connection-menu-item-test"
                    (click)="onActionMenu(connection, 'test')"
                  >
                    <mat-icon
                      class="menu-icon menu-mat-icon"
                      [attr.matMenuItemIcon]="''"
                      >autorenew</mat-icon
                    >
                    <span class="connection-menu-item-label">Test</span>
                  </button>
                  @if (canDuplicate(connection)) {
                    <button
                      mat-menu-item
                      class="connection-menu-item connection-menu-item-duplicate"
                      (click)="onActionMenu(connection, 'duplicate')"
                    >
                      <mat-icon
                        class="menu-icon menu-mat-icon"
                        [attr.matMenuItemIcon]="''"
                        >content_copy</mat-icon
                      >
                      <span class="connection-menu-item-label">Duplicate</span>
                    </button>
                  }
                  <button
                    mat-menu-item
                    class="connection-menu-item connection-menu-item-remove menu-item-remove"
                    (click)="onActionMenu(connection, 'delete')"
                  >
                    <img
                      [attr.matMenuItemIcon]="''"
                      src="assets/icons/connection-remove.svg"
                      alt=""
                      class="menu-icon"
                      width="16"
                      height="16"
                    />
                    <span class="connection-menu-item-label">Delete</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          }
        </div>
      }
    }
  </mat-card>
</div>
